import React, { memo } from "react";
import { withStyles } from "@material-ui/core";
import { TimeRangeEditor } from '@dataGrid/components/cellEditors';
import constants from "../../../../../appConstants";

const style = (theme) => ({
  timeContainer: {
    marginLeft: 3,
    marginBottom: 8,
  },
});

const TimeRange = (props) => {
  const updateTime = (time) => {
    if (time && time !== "Invalid_Time") {
      props.onClick({
        predicate: handlePredicate(time),
        isApplied: true,
      });
    }
    if (!time) {
      props.onClick({
        predicate: handlePredicate(props.defaultTime),
        isApplied: false,
      });
    }
  };

  const handlePredicate = (time) => {
    const [start, end] = time.split(" - ");
    const predicate = props.filter.predicate.split(" ");
    if (props.isInBetweenOperand) {
      predicate[2] = `${start}-${end}`;
    } else {
      predicate[2] = start;
      predicate[6] = end;
    }
    return predicate.join(" ");
  };

  return (
    <div className={props.classes.timeContainer}>
      <TimeRangeEditor
        DATETYPE={constants.DATETYPES.TIME}
        isTimeInterval={true}
        value=""
        onChange={updateTime}
        componentSpecificProps={{
          startLabel: "",
          endLabel: "",
          isInputBorderRequired: false,
        }}
      />
    </div>
  );
};

export default withStyles(style)(memo(TimeRange));
